import React from "react";
import { Stack } from "react-bootstrap";
import { LomavisShortenedNumber } from "@/lomavisSharedUi/atoms/utils/numbers/LomavisShortenedNumber";

interface LomavisGrowthBadge2Props {
    before: number;
    after: number;
    blur?: boolean;
}

/**
 * Atom: LomavisGrowthBadge2
 *
 * Calculates and shows the growth percentage between `before` and `after`.
 */
export const LomavisGrowthBadge2: React.FC<LomavisGrowthBadge2Props> = ({
                                                                            before,
                                                                            after,
                                                                            blur = false,
                                                                        }) => {
    const delta = after - before;
    const percentChange = before === 0 ? 0 : (delta / before) * 100;

    const getColorClass = () => {
        if (percentChange > 0) return "text-success";
        if (percentChange < 0) return "text-danger";
        return "text-muted";
    };

    const getArrow = () => {
        if (percentChange > 0) return "▲";
        if (percentChange === 0) return "";
        if (percentChange < 0 && Math.abs(percentChange) > 0) return "▼";
        return "–";
    };

    return (
        <Stack
            className={`ms-1 ${getColorClass()} small badge badge-white`}
            style={{
                opacity: blur ? 0.6 : 1,
                filter: blur ? "blur(2px)" : "none",
            }}
            direction="horizontal"
        >
            {getArrow()} &nbsp; <LomavisShortenedNumber value={Math.abs(percentChange) < 0.01 ? 0 : parseFloat(Math.abs(percentChange).toFixed(2))} />&nbsp;%
        </Stack>
    );
};
